import axios from 'axios';

// 登录请求方法
const loginreq = (method, url, params) => {
    return axios({
        method: method,
        url: url,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        data: params,
        traditional: true,
        transformRequest: [
            function(data) {
                let ret = ''
                for (let it in data) {
                    ret +=
                        encodeURIComponent(it) +
                        '=' +
                        encodeURIComponent(data[it]) +
                        '&'
                }
                return ret
            }
        ]
    }).then(res => res.data);
};
/**
 * 通用公用方法 表单请求
 * @param method
 * @param url
 * @param params
 * @returns {Q.Promise<any> | Function | any | PromiseLike<any>}
 */
const req = (method, url, params) => {
    return axios({
        method: method,
        url: url,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            token: localStorage.getItem('logintoken')
        },
        data: params,
        traditional: true,
        transformRequest: [
            function(data) {
                let ret = ''
                for (let it in data) {
                    ret +=
                        encodeURIComponent(it) +
                        '=' +
                        encodeURIComponent(data[it]) +
                        '&'
                }

                return ret
            }
        ]
    }).then(res => res.data);
};

/**
 * 发送json格式请求
 * @param method
 * @param url
 * @param params
 * @returns {Q.Promise<any> | Function | any | PromiseLike<any>}
 */
const reqJson = (method, url, params) => {
  console.log("请求参数信息===="+JSON.stringify(params)+"====")
  return axios({
    method: method,
    url: url,
    headers: {
      'Content-Type': 'application/json',
      token: localStorage.getItem('logintoken')
    },
    data: JSON.stringify(params),
    //传统方式序列化
    traditional: true
  }).then(res => res.data);
};

export {
    loginreq,
    req,
    reqJson
}



// WEBPACK FOOTER //
// ./src/api/axiosFun.js